.icon-wrapper {
    border-radius: 100%;
    background: var(--icon--wrapper-color, var(--theme--color--grey--light));
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.icon {
  color: var(--icon--color, inherit)
}